import { createBrowserHistory } from "history";

export const history = createBrowserHistory();

history.listen((location, action) => {
  // this block applies before react-router
  if (action === "POP") {
    if (location.state) {
      // in case of back/forward we need to make force re-upload data
      // to be sure about the newest state
      const { state, ...locationWithoutState } = location;
      history.replace(locationWithoutState);
    }
  }
  // Use setTimeout to make sure this runs after React Router's own listener
  setTimeout(() => {
    // Keep default behavior of restoring scroll position when user:
    // - clicked back button
    // - clicked on a link that programmatically calls `history.goBack()`
    // - manually changed the URL in the address bar (here we might want
    // to scroll to top, but we can't differentiate it from the others)
    if (location.action === "POP") {
      return;
    }
    // In all other cases, scroll to top
    window.scrollTo(0, 0);
  });
});
